import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { environment } from '../../../environments/environment';
import { OasisAuthService } from './oasis-auth.service';

/**
 * Attaches the Cognito access token as `Authorization: Bearer …` to any
 * request whose URL targets the OASIS-external API. Other URLs (e.g. S3
 * presigned PUTs/GETs which carry their own signed query string) are left
 * untouched.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
	if (!req.url.startsWith(environment.oasisApiBase)) {
		return next(req);
	}
	const token = inject(OasisAuthService).accessToken();
	if (!token) return next(req);

	return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
